import { Button, Space, DatePicker } from '@bancobarigui/barihaus';
import { Space as AntSpace } from 'antd';
import {
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';
import locale from 'antd/es/date-picker/locale/pt_BR';
import { CalendarView } from '../types';

interface CalendarToolbarProps {
  currentDate: Date;
  view: CalendarView;
  loading: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
  onDateSelect: (date: Date) => void;
}

export function CalendarToolbar({
  currentDate,
  view,
  loading,
  onPrevious,
  onNext,
  onToday,
  onDateSelect,
}: CalendarToolbarProps) {
  // Capitalizar primeira letra do mês
  const formatMonth = (date: Dayjs) => {
    const formatted = date.format('MMMM YYYY');
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  // Verificar se está no mês/ano atual
  const isCurrentMonth = dayjs(currentDate).isSame(dayjs(), 'month') && dayjs(currentDate).isSame(dayjs(), 'year');

  return (
    <div>
      {/* Navegação */}
      <Space size="small" wrap>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          {/* Botão "Hoje" para voltar para o mês atual - só aparece se não estiver no mês atual */}
          {!isCurrentMonth && (
            <Button
              type="text"
              size="small"
              onClick={onToday}
              disabled={loading}
              style={{
                position: 'absolute',
                top: '-12px',
                right: '50%',
                transform: 'translateX(50%)',
                zIndex: 10,
                padding: '0 4px',
                height: '20px',
                fontSize: '11px',
                lineHeight: '20px',
              }}
            >
              Hoje
            </Button>
          )}

          <AntSpace.Compact>
            <Button
              icon={<LeftOutlined />}
              onClick={onPrevious}
              disabled={loading}
            >
              {''}
            </Button>

            {/* Seletor de Mês/Ano */}
            <DatePicker
              picker="month"
              value={dayjs(currentDate)}
              onChange={(date: Dayjs | null) => {
                if (date) {
                  onDateSelect(date.toDate());
                }
              }}
              format={formatMonth}
              allowClear={false}
              disabled={loading}
              locale={locale}
            />

            <Button
              icon={<RightOutlined />}
              onClick={onNext}
              disabled={loading}
            >
              {''}
            </Button>
          </AntSpace.Compact>
        </div>
      </Space>
    </div>
  );
}
